import React from "react"
import { graphql, useStaticQuery } from "gatsby"
// import { getImage } from "gatsby-plugin-image"
// import { convertToBgImage } from "gbimage-bridge"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"
import { motion } from "framer-motion"
// import { Location } from "@reach/router"

function FadeInWhenVisible({ children }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },
      }}
    >
      {children}
    </motion.div>
  )
}

const About = ({ content }) => {
  const { frontmatter, body } = content[0].node
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            minibio
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social

  return (
    <MDXProvider
      components={{
        p: props => (
          <p
            {...props}
            className="text-lg md:text-2xl font-normal mt-10 px-4 leading-loose tracking-wider text-left text-main"
          />
        ),
        em: props => (
          <em
            {...props}
            className="text-2xl font-medium font-sans text-gray-500 italic"
          />
        ),
      }}
    >
      <FadeInWhenVisible>
        <section
          id="about"
          className="w-10/12 lg:w-1/2 xl:w-7/12 mx-auto my-14 md:my-24 xl:my-44 scroll-mt-44 lg:scroll-mt-60"
        >
          <header>
            <p className="font-body2 text-3xl md:text-4xl lg:text-5xl font-bold mb-12 uppercase text-center tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-blue-500 to-gray-900 dark:from-gray-700 dark:via-gray-300 dark:to-white">
              About me
            </p>
          </header>
            <article 
                itemScope
                itemType="http://schema.org/Article">
              <div className="w-full snap-y mt-24">
                <MDXRenderer>{body}</MDXRenderer>
              </div>
            </article>
        </section>

      </FadeInWhenVisible>
    </MDXProvider>
  )
}

export default About
